import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { AUTOMATION_RULES_API } from '../api/automation-rules-api'
import { AutomationRuleViewInterface } from '../types/automation-rule-interface'

export const useCreateRule = (
  props?: Pick<Parameters<typeof useFetch>[0], 'showFieldsErrorToast'>,
) => {
  const { fetcher } = useFetch<RequestMethodsEnum.post, AutomationRuleViewInterface>({
    method: RequestMethodsEnum.post,
    ...props,
  })
  return {
    fetcher: async (data: string) =>
      fetcher(`${AUTOMATION_RULES_API}`, data, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }),
  }
}
